import {hasFlag, translation} from "@2d-front-monorepo/core";
import {JSX, useMemo} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {Attachments} from "../Attachments";
import {VehiclePropertyFlags} from "../index";
import {VehicleResult} from "../types/VehicleResult";
import AttachmentsComponent from "./AttachmentsComponent";
import ExpiredAttachmentsComponent from "./ExpiredAttachmentsComponent";

export interface VehicleComponentProps {
	vehicle: VehicleResult;
	filesPrefix: string;
	hiddenEntityProperties: VehiclePropertyFlags,
}

export default function VehicleComponent({vehicle, filesPrefix, hiddenEntityProperties}: VehicleComponentProps): JSX.Element {
	const data = vehicle.data;
	const expired = useMemo(() => Attachments.findExpired(vehicle), [vehicle]);

	return (
		<div className="card card--driver">
			<div className="grid padded">
				<dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.vehicle__plate)}</dt>
					<dd>{vehicle.plate}</dd>
				</dl>
				{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Nickname) &&
                    <dl className="title-desc col-1of4">
                        <dt>{translation(PermitTranslations.vehicle__nickname)}</dt>
                        <dd>{data?.nickname}</dd>
                    </dl>
				}
				{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Model) &&
                    <dl className="title-desc col-1of4">
                        <dt>{translation(PermitTranslations.vehicle__model)}</dt>
                        <dd>{data?.model}</dd>
                    </dl>
				}
				{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Color) &&
                    <dl className="title-desc col-1of4">
                        <dt>{translation(PermitTranslations.vehicle__color)}</dt>
                        <dd>{data?.color}</dd>
                    </dl>
				}
				{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Type) &&
                    <dl className="title-desc col-1of4">
                        <dt>{translation(PermitTranslations.vehicle__type)}</dt>
                        <dd>{data?.type}</dd>
                    </dl>
				}
				{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Province) &&
                    <dl className="title-desc col-1of4">
                        <dt>{translation(PermitTranslations.vehicle__province)}</dt>
                        <dd>{data?.province}</dd>
                    </dl>
				}
				<AttachmentsComponent entity={vehicle} linkPrefix={filesPrefix} className="col-full"/>
				<ExpiredAttachmentsComponent attachments={expired} linkPrefix={filesPrefix} className="col-full"/>
			</div>
		</div>
	);
}
